import { render, staticRenderFns } from "./step-btn.vue?vue&type=template&id=0068ae2c&scoped=true"
import script from "./step-btn.ts?vue&type=script&lang=ts&external"
export * from "./step-btn.ts?vue&type=script&lang=ts&external"
import style0 from "./step-btn.scss?vue&type=style&index=0&id=0068ae2c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068ae2c",
  null
  
)

export default component.exports